module.exports = __webpack_public_path__ + "img/art-work-icon12.d3452aa9.png";